const BANK_PUBLIC_OPTIONS_TTL_MS = 30 * 1000

let cachedOptions = null
let cacheExpiresAt = 0
let inFlightRequest = null

function cloneOptions (options) {
  return Object.keys(options || {}).reduce((result, key) => {
    result[key] = { ...(options[key] || {}), id: key, key }
    return result
  }, {})
}

export function clearBankPublicOptionsCache () {
  cachedOptions = null
  cacheExpiresAt = 0
  inFlightRequest = null
}

export function getBankPublicOptionsOnce (database) {
  const now = Date.now()
  if (cachedOptions && now < cacheExpiresAt) return Promise.resolve(cloneOptions(cachedOptions))
  if (inFlightRequest) return inFlightRequest.then(cloneOptions)

  inFlightRequest = database.ref('/bank_public_options').once('value').then(snapshot => {
    cachedOptions = snapshot.val() || {}
    cacheExpiresAt = Date.now() + BANK_PUBLIC_OPTIONS_TTL_MS
    return cachedOptions
  })
  inFlightRequest = inFlightRequest.then(
    options => {
      inFlightRequest = null
      return options
    },
    error => {
      inFlightRequest = null
      throw error
    }
  )
  return inFlightRequest.then(cloneOptions)
}

